import { useEffect, useState } from 'react';
import { useGetAIMetadataQuery } from '../redux/services/ai-api';

export const OdinAIEnabledKey = 'viking_ai_usage_enabled';
export const DashboardAIEnabledKey = 'widget_ai_insights_enabled';
export const RecordAIEnabledKey = 'record_ai_enabled';
export const BowtieAIEnabledKey = 'bowtie_ai_usage_enabled';

/**
 * Custom hook to check if an AI flag is enabled.
 * It fetches the AI metadata and checks the value of the flag.
 *
 * @returns {Object} - An object containing:
 *   - enabled: boolean indicating if AI flag is enabled
 *   - isLoading: boolean indicating if the data is still loading
 *   - isFetching: boolean indicating if a fetch request is in progress
 */
const useAIFlagEnabled = (flag: string) => {
  const { data, isLoading, isFetching } = useGetAIMetadataQuery();
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (!isFetching && data) {
      const aiEnabledApi = data.find((item) => item.key === flag)?.value ?? 'false';
      if (aiEnabledApi === 'true') {
        setEnabled(true);
      } else if (aiEnabledApi === 'false') {
        setEnabled(false);
      }
    }
  }, [data, isFetching]);

  return {
    enabled,
    isLoading,
    isFetching,
  };
};

export default useAIFlagEnabled;
